export default {"src":"/_next/static/media/helmet-outline.203684c6.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};